<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-if="professor">{{ professor }}</dd>
  </div>
</template>

<script>
import ProfessorService from "../../../../domain/corpore/ProfessorService";
import CampoEnum from "../../../../domain/protocolo/CampoEnum";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-professor",
  props: {
    label: String,
    value: String
  },
  asyncComputed: {
    professor() {
      if (this.value) {
        const professorService = new ProfessorService(this.$http);
        return professorService
          .getProfessoresByCodprof(this.value)
          .then(professor => professor.nome)
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/Professor.vue